import { defineSaleProgress, hasAddress, isSaleCreated, type ProgressSaleData } from '../saleProgress'

interface LeadTelecomData extends ProgressSaleData {
  leadType?: string | null
}

const TIMELINE = 'additionalSales:pulse.timeline.'

export default defineSaleProgress<LeadTelecomData>({
  kind: 'lead',
  steps: [
    { key: 'address', label: `${TIMELINE}address`, done: hasAddress },
    { key: 'qualified', label: `${TIMELINE}qualified`, done: data => !!data.leadType },
    { key: 'lead_created', label: `${TIMELINE}lead_created`, done: isSaleCreated },
  ],
  status: (data, steps) => {
    if (steps[steps.length - 1].state === 'done') return 'signed'
    if (steps.some(step => step.state === 'done') || !!data.actionsInProgress) return 'progress'

    return 'new'
  },
})
